import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNewPassword } from '../actions/auth-actions';
import { Box, Flex } from '@chakra-ui/react';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';


function SetNewPasswordForm({
	resetPasswordToken,
	// Action
	setNewPassword
}) {

	const [localState, setLocalState] = useState({
		inputPassword: "",
		repeatPassword: "",
	})
	const [showLoader, setShowLoader] = useState(null)
	const [showValidationError, setShowValidationError] = useState(null)
	const { inputPassword, repeatPassword } = localState;

	const handleChange = (event) => {
		const value = event.target.value;

		setLocalState(prevState => ({
			...prevState,
			[event.target.name]: value
		}));

		!!showValidationError && setShowValidationError(false)
	}

	const submitSetNewPassword = () => {

		const sameInputs = ((inputPassword && inputPassword.length > 5) && (inputPassword === repeatPassword)) ? true : false;

		if (sameInputs) {
			setNewPassword(
				inputPassword,
				resetPasswordToken
			)

			setShowLoader(true)
		}

		if (!sameInputs) {
			setShowValidationError(true)
		}
	}


	if (showLoader) {
		return (
			<PageLoader />
		)
	} else {
		return (
			<Box w="100%" align="center" maxW='25em'>

				<Box fontSize='1.4em' mb='1.5em' color='brandDark.500' w='100%'>Set new password</Box>
				<Flex direction='column' gap='1em' w='100%' align='center'>

					<LaunchdeckFormInput
						label='New password'
						name={'inputPassword'}
						onChange={handleChange}
						value={inputPassword || ""}
						type='password'
					/>

					<LaunchdeckFormInput
						label='Confirm password'
						name={'repeatPassword'}
						onChange={handleChange}
						value={repeatPassword || ""}
						type='password'

						errorLogic={showValidationError}
						errorMessage="Your confirmation password did not match, or needs to be more than 6 characters"
					/>

					<Box mt='1em' w='100%'>
						<LaunchdeckButton bg='brand.500' color='white' w='100%' onClick={() => submitSetNewPassword()} label='Set new password' />
					</Box>
				</Flex>
			</Box>
		)
	}
};


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setNewPassword
		},
		dispatch,
	)


export default connect(null, mapDispatchToProps)(SetNewPasswordForm);


